<template>
  <router-view />
</template>

<script>
export default {
  name: 'SafariReservationsIndex'
}
</script>
